import { render, staticRenderFns } from "./VirtualVideoNew.vue?vue&type=template&id=6b10936a&"
import script from "./VirtualVideoNew.vue?vue&type=script&lang=js&"
export * from "./VirtualVideoNew.vue?vue&type=script&lang=js&"
import style0 from "./VirtualVideoNew.vue?vue&type=style&index=0&id=6b10936a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CoursesYoutube: require('/opt/build/repo/components/Courses/Youtube.vue').default})
